<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    height="100%"
    transition="dialog-bottom-transition"
    persistent
    scrollable
    no-click-animation
    @keydown.esc="$emit('close')"
  >
    <v-card
      class="elevation-0 ma-auto"
      tile
      width="1400"
      :max-width="$vuetify.breakpoint.mobile ? '95%' : '70%'"
    >
      <div class="pl-16 ml-5 pr-10">
        <CreateMigrationProgressBar />
      </div>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            absolute
            left
            color="white"
            elevation="0"
            class="mt-3"
            v-bind="attrs"
            v-on="on"
            @click="cancel"
          >
            <v-icon color="secondary lighten-2">ph-x</v-icon>
          </v-btn>
        </template>
        <span class="text-capitalize">{{ $t("action.close") }}</span>
      </v-tooltip>

      <v-window v-model="currentStep" touchless style="width: 100%">
        <v-window-item :value="1">
          <MigrationIntroduction @started="currentStep = 2" />
        </v-window-item>

        <v-window-item :value="2">
          <ImportMigrationCSV
            @back="currentStep = 1"
            @advance="currentStep = 3"
          />
        </v-window-item>

        <v-window-item :value="3">
          <MigrationsValidation @back="currentStep = 2" @close="cancel" />
        </v-window-item>
      </v-window>
    </v-card>
  </v-dialog>
</template>

<script>
import CreateMigrationProgressBar from "@/components/migration/CreateMigrationProgressBar.vue";
import MigrationIntroduction from "@/components/migration/MigrationIntroduction.vue";
import ImportMigrationCSV from "@/components/migration/ImportMigrationCSV.vue";
import MigrationsValidation from "@/components/migration/MigrationsValidation.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CreateMigration",

  components: {
    CreateMigrationProgressBar,
    MigrationIntroduction,
    ImportMigrationCSV,
    MigrationsValidation,
  },

  data() {
    return {
      show: true,
    };
  },

  computed: {
    ...mapGetters(["currentCreateMigrationStep"]),

    currentStep: {
      get() {
        return this.currentCreateMigrationStep;
      },
      set(newStep) {
        this.setCreateMigrationStep(newStep);
      },
    },
  },

  methods: {
    ...mapMutations(["setCreateMigrationStep"]),

    cancel() {
      this.setCreateMigrationStep();
      this.$router.push({ name: "MigrationsHistory" });
    },
  },
};
</script>
